<template>
    <div class="container-fluid">
      <div class="row">
        <div class="col bg-light border py-2">
            <table id="myLabAppvTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
                <thead class="text-white" style="background:Navy">
                <tr>
                    <th>สถานะ</th>
                    <th>ชื่อสาขา</th>
                    <th>เลขที่ใบตรวจ</th>
                    <th>วันที่</th>
                    <th>คลินิกส่งตรวจ</th>
                    <th>ชื่อ-สกุล คนไข้</th>
                    <th>เพศ</th>
                    <th style="width:60px">ให้สิทธิ</th>
                    <th style="width:60px">ถอดสิทธิ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in datalists" :key="item.ROID" @click="viewResultRO(item)"
                  v-bind:data-id="item.ROID">
                    <td class="">{{ arrDocStatus[item.Status] }}</td>
                    <td class="text-start">{{ item.BranchName }}</td>
                    <td class="text-start">{{ item.RONo }}</td>
                    <td class="text-start">{{ item.DocDate }}</td>
                    <td class="text-start">{{ item.ReqClinicName }}</td>
                    <td class="text-start">{{ item.PatName }} {{ item.PatLName}}</td>
                    <td class="">{{ arrSex[item.Sex] }} </td>
                    <td class="text-center">
                      <button id="PrintAuto" type="button" v-if="item.RelStatus == 0" title="อนุญาติให้คลินิกต้นทางเข้าถึงผลแล็บ"
                        class="btn btn-outline-success btm-sm py-0" @click="ReleaseLabForClinicReq(item)">
                        <i class="fa fa-eye"></i>
                      </button>
                    </td>
                    <td class="text-center">
                      <button id="PrintAuto" type="button" v-if="item.RelStatus == 1" title="ถอดสิทธิการเข้าถึงผลแล็บ"
                        class="btn btn-outline-danger btm-sm py-0 ms-1" @click="NotReleaseLabForClinicReq(item)">
                        <i class="fa fa-eye-slash"></i>
                      </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
      </div>
    </div>
</template>

<script>
// import axios from 'axios'
// import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

// import JsBarcode from 'jsbarcode/bin/JsBarcode'

// import pdfMake from 'pdfmake'
// import pdfFonts from 'pdfmake/build/vfs_fonts'
// import htmlToPdfmake from 'html-to-pdfmake'
// pdfMake.vfs = pdfFonts.pdfMake.vfs
// // ต้องระบุตามชื่อของ ไฟล์ font
// pdfMake.fonts = {
//   THSarabunNew: {
//     normal: 'THSarabunNew.ttf',
//     bold: 'THSarabunNew-Bold.ttf',
//     italics: 'THSarabunNew-Italic.ttf',
//     bolditalics: 'THSarabunNew-BoldItalic.ttf'
//   },
//   Roboto: {
//     normal: 'Roboto-Regular.ttf',
//     bold: 'Roboto-Medium.ttf',
//     italics: 'Roboto-Italic.ttf',
//     bolditalics: 'Roboto-MediumItalic.ttf'
//   }
// }

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    var globalCorpInfo = inject('corpInfo', {})
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition, globalCorpInfo
    }
  },
  name: 'LabPrint1View',
  data () {
    return {
      arrRepeatChk: ['', 'R'],
      arrSex: ['', 'Male', 'Female'],
      arrSexTh: ['', 'ชาย', 'หญิง'],
      arrDocStatus: ['New', 'Lab', 'Resulted', 'AP'],
      arrPayType: ['เงินสด', 'เครดิต'],

      // ตัวแปรสำหรับพิมพ์แบบฟอร์ม Covid
      dataheader: null,
      reportDtl: null,
      reportHd: {
        BranchID: 0,
        ROID: 0,
        RONo: '',
        DocDate: null,
        DocTime: null,
        PatID: 0,
        PatCode: '',
        PrefixName: '',
        PatName: 'สมชาย แข็งแรงดี',
        PatLName: '',
        PrefixName2: '',
        PatName2: '',
        PatLName2: '',
        IDNo: '',
        Sex: 0,
        Tel1: '',
        Tel2: '',
        AgeYears: 0,
        AgeMonths: 0,
        AgeDays: 0,
        ReqClinicID: 0,
        ReqClinicName: '',
        HNNo: '',
        OfficerID1: 0,
        OfficerName1: '',
        OfficerName1Sign: '',
        OfficerID2: 0,
        OfficerName2: '',
        OfficerName2Sign: '',
        ResultedDate: null,
        OfficerID3: 0,
        OfficerName3: '',
        OfficerName3Sign: '',
        ApprovedDate: null,
        Remark: '',
        Status: 0
      },
      // ตัวแปรสำหรับพิมพ์แบบ A5 มีชื่อชุดตรวจ
      A5dataheader: null,
      A5reportHd: {
        BranchID: 0,
        ROID: 0,
        RONo: '',
        DocDate: null,
        DocTime: null,
        PatID: 0,
        PatCode: '',
        PrefixName: '',
        PatName: 'สมชาย แข็งแรงดี',
        PatLName: '',
        PrefixName2: '',
        PatName2: '',
        PatLName2: '',
        IDNo: '',
        Sex: 0,
        Tel1: '',
        Tel2: '',
        AgeYears: 0,
        AgeMonths: 0,
        AgeDays: 0,
        ReqClinicID: 0,
        ReqClinicName: '',
        HNNo: '',
        OfficerID1: 0,
        OfficerName1: '',
        OfficerName1Sign: '',
        OfficerID2: 0,
        OfficerName2: '',
        OfficerName2Sign: '',
        ResultedDate: null,
        OfficerID3: 0,
        OfficerName3: '',
        OfficerName3Sign: '',
        ApprovedDate: null,
        Remark: '',
        Status: 0
      },
      A5GroupTest: [],
      A5reportDtl: []
    }
  },
  props: ['datalists'],
  mounted () {

  },
  components: {

  },
  methods: {
    NotReleaseLabForClinicReq (row) {
      var self = this
      Swal.fire({
        title: 'คุณต้องการ ยกเลิก การให้สิทธิคลินิกต้นทางพิมพ์ข้อมูลได้<br>ใช่หรือไม่?',
        text: row.RONo + '\n' + row.PatName + ' ' + row.PatLName,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่! แน่ใจ',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: this.http_baseurl + 'setdata/update_ro_relstatus.php',
            data: { ROID: row.ROID, UserID: self.globalUserID, RelStatus: 0 }
          }).done(function () {
            Swal.fire({
              text: 'คลินิกต้นทางไม่สามารถพิมพ์ผลแล็บใบนี้ได้แล้ว!!',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            }).then((result) => {
              self.backPageAfterSave()
            })
          })
        }
      })
    },
    ReleaseLabForClinicReq (row) {
      var self = this
      Swal.fire({
        title: 'คุณต้องการ อนุญาติให้คลินิกต้นทางพิมพ์ข้อมูลได้<br>ใช่หรือไม่?',
        text: row.RONo + '\n' + row.PatName + ' ' + row.PatLName,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่! แน่ใจ',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: this.http_baseurl + 'setdata/update_ro_relstatus.php',
            data: { ROID: row.ROID, UserID: self.globalUserID, RelStatus: 1 }
          }).done(function () {
            Swal.fire({
              text: 'อนุญาติให้คลินิกต้นทางพิมพ์ผลแล็บ เสร็จเรียบร้อย',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            }).then((result) => {
              self.backPageAfterSave()
            })
          })
        }
      })
    },
    // แปลงรูปแบบการแสดงผลแล็บ ถ้าเป็นตัวเลขใส่คอมม่าและทศนิมยม ถ้าไม่ใช่แสดงค่าเดิม
    FormatNumResult (row) {
      if (this.isNumber(row.Result) && (row.Result.trim() !== '')) {
        return Number(row.Result).toFixed(row.Decimals)
      } else {
        return row.Result
      }
    },
    // ตรวจสอบว่าเป็นตัวเลขหรือไม่
    isNumber (val) {
      return !isNaN(val)
    },
    viewResultRO (row) {
      // console.log(row)
      this.$emit('onViewResultEvent', row)
    },
    backPageAfterSave () {
      this.$emit('onBackPageAfterSaveEvent')
    }
  }
}
</script>
